import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    workTeamItemSelected: null
}

const workTeamItemSlice = createSlice({
    name: 'workTeamItemStateSlice',
    initialState,
    reducers: {
        setWorkTeamItemSelected: (state, action) => {
            state.workTeamItemSelected = action.payload
        }
    }
})  

export const { setWorkTeamItemSelected } = workTeamItemSlice.actions
export default workTeamItemSlice.reducer